import cn from 'clsx';
import React, { FC } from 'react';

interface ContainerProps {
  className?: string;
  children?: any;
  el?: HTMLElement;
  clean?: boolean;
  excludePaddingX?: boolean; 
}

const Container: FC<ContainerProps> = ({
  children,
  className,
  el = 'div',
  clean = false,
  excludePaddingX = false, 
}) => {
  const rootClassName = cn(className, {
    'mx-auto max-w-7xl w-full': !clean,
    'px-3': !clean && !excludePaddingX, 
  });

  let Component: React.ComponentType<React.HTMLAttributes<HTMLDivElement>> =
    el as any;

  return <Component className={rootClassName}>{children}</Component>;
};

export default Container;
